<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Data" prop="data" :rules="[$requiredChange]" key="data">
              <el-date-picker v-model="dados.data" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Quantidade preparada" prop="quantidade_preparada" :rules="[$requiredBlur]" key="quantidade_preparada">
              <el-input v-model="dados.quantidade_preparada" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Receita" prop="receita_id" :rules="[$requiredChange]" key="receita_id">
              <el-select v-model="dados.receita_id" placeholder="pesquisar" filterable remote clearable :remote-method="searchReceita" :loading="loadingReceita">
                <el-option v-for="r in receitas" :key="r.id" :label="r.nome" :value="r.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Cardápio (opcional)" key="cardapio_id">
              <el-select v-model="cardapioSelected" placeholder="Selecione" clearable filterable @change="loadCardapioItens">
                <el-option v-for="c in cardapios" :key="c.id" :label="cardapioLabel(c)" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Item do cardápio (opcional)" key="cardapio_item_id">
              <el-select v-model="dados.cardapio_item_id" placeholder="Selecione" clearable filterable>
                <el-option v-for="i in cardapioItens" :key="i.id" :label="itemLabel(i)" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-consumo" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    edit: false,
    loadingReceita: false,
    receitas: [],
    cardapios: [],
    cardapioSelected: '',
    cardapioItens: [],
    filtroInstituicao: { id: '', nome: '' },
    dados: {
      id: '',
      instituicao_id: '',
      data: '',
      cardapio_item_id: '',
      receita_id: '',
      quantidade_preparada: 1
    }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
    this.loadCardapios()
  },
  methods: {
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/consumo/getById/` + id, this.$store.getters.getHeaderAuth)
      const data = JSON.parse(JSON.stringify(res.data))

      // Pré-popular options para o el-select remote (senão ele mostra o ID)
      if (data && data.receita) {
        this.receitas = [{ id: data.receita.id, nome: data.receita.nome }]
        delete data.receita
      }

      // Item do cardápio (select normal) também precisa ter option carregado
      if (data && data.cardapio_item) {
        this.cardapioItens = [data.cardapio_item]
        this.cardapioSelected = data.cardapio_item.cardapio_id
        delete data.cardapio_item
      }

      this.dados = data
    },
    searchReceita (query) {
      if (!query || query.length < 2) { this.receitas = []; return }
      this.loadingReceita = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/receita/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.receitas = JSON.parse(JSON.stringify(res.data)); this.loadingReceita = false })
        .catch(e => { this.loadingReceita = false; this.$store.commit('throwException', e) })
    },
    async loadCardapios () {
      const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
      if (!instituicaoId) return
      const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio/getAllPaginate`, { instituicao_id: instituicaoId }, this.$store.getters.getHeaderAuth)
      this.cardapios = res.data.data || []
    },
    async loadCardapioItens () {
      this.cardapioItens = []
      this.dados.cardapio_item_id = ''
      if (!this.cardapioSelected) return
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/cardapio/getById/` + this.cardapioSelected, this.$store.getters.getHeaderAuth)
      this.cardapioItens = res.data.itens || []
    },
    onSubmit () {
      document.getElementById("btn-consumo").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        const inst = this.$store.state.config.instituicao
        if (!inst || !inst.id) {
          return window.eventBus.$emit('alert', { msg: 'Selecione uma instituição antes de salvar.', type: 'warning' })
        }
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = inst.id
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/consumo/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
          } else {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/consumo/store`, this.dados, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitConsumo')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    },
    cardapioLabel (c) {
      const ini = c.data_inicio ? c.data_inicio : '?'
      const fim = c.data_fim ? c.data_fim : '?'
      return `#${c.id} (${ini} - ${fim})`
    },
    itemLabel (i) {
      const dias = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB']
      const d = (i.dia_semana !== null && i.dia_semana !== undefined) ? dias[i.dia_semana] : '-'
      return `${d} - ${i.refeicao || ''} - ${i.descricao || ''}`.trim()
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        }
      }
    }
  }
}
</script>

